PriceSettingsDirective.$inject = ['$rootScope'];
function PriceSettingsDirective($rootScope) {
    return {
        template: require('./views/price-settings.html'),
        link: function (scope, attrs, elem) {
            scope.$watch('show_vat', function (nval, oval) {
                $rootScope.show_vat = scope.show_vat;
            });
            scope.$watch('currency', function (nval, oval) {
                $rootScope.currency = scope.currency;
            });
            scope.$watch('show_prices', function (nval, oval) {
                $rootScope.show_prices = scope.show_prices;
            });
        }
    };
}
angular.module('rinca.core.directives.priceSettings', [])
    .directive('priceSettings', PriceSettingsDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/directives/PriceServiceDirective.js
// module id = 314
// module chunks = 0